(function(){
/* ==========================================================
   HERO — carusel infinit, cu repoziționare sigură (fără
   dependență de transitionend)
   ========================================================== */
function init(){
  var r=document.getElementById('rxSlider'),tr=document.getElementById('rxTrack');
  if(!r||!tr||r.dataset.rxInit)return;r.dataset.rxInit='1';
  var real=Array.prototype.slice.call(tr.querySelectorAll('.rx-slide'));
  var n=real.length;if(!n)return;
  var dots=r.querySelectorAll('.rx-dots button');
  var DUR=700;

  if(n>1){
    var head=real[0].cloneNode(true),tail=real[n-1].cloneNode(true);
    head.classList.add('is-clone');tail.classList.add('is-clone');
    tr.appendChild(head);
    tr.insertBefore(tail,real[0]);
  }
  var slides=Array.prototype.slice.call(tr.querySelectorAll('.rx-slide'));
  var i=n>1?1:0,busy=false,auto=null,live=true;
  var drag=false,sx=0,sy=0,dx=0,lock=null,w=0;

  function width(){return r.getBoundingClientRect().width}
  function apply(px,useAnim){
    tr.style.transition=useAnim?('transform '+DUR+'ms var(--ease)'):'none';
    tr.style.transform='translate3d('+px+'px,0,0)';
  }
  function realIdx(){return ((i-1)%n+n)%n}
  function paint(){
    var k=realIdx();
    slides.forEach(function(e,x){e.classList.toggle('is-on',x===i)});
    dots.forEach(function(e,x){e.classList.toggle('is-on',x===k)});
  }
  function settle(){
    /* după animație, dacă stăm pe o clonă, sărim instant la echivalentul real */
    if(n<2)return;
    if(i>n){i=1;apply(-i*width(),false)}
    else if(i<1){i=n;apply(-i*width(),false)}
    paint();busy=false;
  }
  function go(next){
    if(busy||n<2){return}
    busy=true;i=next;apply(-i*width(),true);paint();
    setTimeout(settle,DUR+30);
  }
  function play(){if(!live||n<2)return;stop();auto=setInterval(function(){go(i+1)},6500)}
  function stop(){if(auto){clearInterval(auto);auto=null}}
  function halt(){live=false;stop()}

  var p=r.querySelector('.rx-arrow--prev'),nx=r.querySelector('.rx-arrow--next');
  if(p)p.onclick=function(){halt();go(i-1)};
  if(nx)nx.onclick=function(){halt();go(i+1)};
  dots.forEach(function(e,x){e.onclick=function(){halt();if(!busy)go(x+1)}});

  function down(x,y){if(busy)return;drag=true;sx=x;sy=y;dx=0;lock=null;w=width();stop();tr.style.transition='none'}
  function move(x,y,e){
    if(!drag)return;
    var mx=x-sx,my=y-sy;
    if(lock===null){
      if(Math.abs(mx)<6&&Math.abs(my)<6)return;
      lock=Math.abs(mx)>Math.abs(my)?'x':'y';
    }
    if(lock==='y'){drag=false;apply(-i*w,true);return}
    if(e&&e.cancelable)e.preventDefault();
    dx=mx;apply(-i*w+dx,false);
  }
  function up(){
    if(!drag)return;drag=false;
    if(lock!=='x'){apply(-i*w,true);return}
    halt();
    if(Math.abs(dx)>w*.14||Math.abs(dx)>60)go(i+(dx<0?1:-1));
    else{apply(-i*w,true)}
  }

  r.addEventListener('touchstart',function(e){down(e.touches[0].clientX,e.touches[0].clientY)},{passive:true});
  r.addEventListener('touchmove',function(e){move(e.touches[0].clientX,e.touches[0].clientY,e)},{passive:false});
  r.addEventListener('touchend',up,{passive:true});
  r.addEventListener('touchcancel',up,{passive:true});
  r.addEventListener('mousedown',function(e){
    if(e.button!==0)return;
    if(e.target.closest('.rx-arrow,.rx-dots,.rx-btn'))return;
    down(e.clientX,e.clientY);r.classList.add('is-grabbing');
  });
  window.addEventListener('mousemove',function(e){if(drag)move(e.clientX,e.clientY,e)});
  window.addEventListener('mouseup',function(){r.classList.remove('is-grabbing');up()});
  r.addEventListener('click',function(e){if(Math.abs(dx)>8){e.preventDefault();e.stopPropagation()}},true);
  r.addEventListener('dragstart',function(e){e.preventDefault()});
  r.addEventListener('mouseenter',stop);
  r.addEventListener('mouseleave',play);
  var rt;window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(function(){apply(-i*width(),false)},150)});

  apply(-i*width(),false);paint();play();
}
if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
document.addEventListener('shopify:section:load',init);
})();